import React, { Component } from 'react'
import './ButtonGray.css'

export default class ButtonGray extends Component {
    render() {
        return (
            <button {...this.props} className={"btn-tertium-gray "+this.props.className}>{ this.props.children }</button>
        )
    }
}